/**
 * ProgressCircle component.
 */
import Circle from '@components/atoms/icons/progressCircle';
import Container from '@components/atoms/container/progressCircleContainer';
import { TRANSITION } from '@shared/types/constants/animations';

/**
 * Props for the ProgressCircle component.
 * @param {string} color - Color of the progress circle.
 * @param {boolean} margin - Margin of the progress circle.
 * @param {number} percentage - Percentage of the progress circle.
 * @param {string} text - Text of the progress circle.
 */
interface Props {
  color?: string;
  margin?: boolean;
  percentage?: number;
  text: string;
}

/**
 * Renders the progress circle component.
 * @param {string} color - Color of the progress circle.
 * @param {boolean} margin - Margin of the progress circle.
 * @param {number} percentage - Percentage of the progress circle.
 * @param {string} text - Text of the progress circle.
 * @returns {JSX.Element} Progress circle component.
 */
export default function ProgressCircle({
  color,
  margin = true,
  percentage,
  text,
}: Props) {
  return (
    <Container
      id={'progressCircle'}
      transition={TRANSITION.OPACITY_TRANSITION}
      margin={margin}
    >
      <Circle
        percentage={percentage}
        strokeColor={color}
        text={text.toUpperCase()}
        textColor={'#FFFF'}
      />
    </Container>
  );
}
